class SsoController {
  constructor(SsoAuthorizationService, config, $state, $cookies) {
    this.sso = SsoAuthorizationService;
    this.config = config;
    this.$state = $state;
    this.$cookies = $cookies;
    this.error = null;
  }

  $onInit(){
    const accessToken = this.$cookies.get('am_access_token') || '';

    if(accessToken){
      this.sso.onSsoResolve(accessToken);
    }else{
      const errorToken = this.$cookies.get('am_error_msg') || '';
      this.$cookies.remove('am_error_msg');
      this.sso.onSsoFailure(errorToken);
    }
  }

  isError(){
    this.error = this.sso.isError ? this.sso.errorMsg : null;
    return this.sso.isError; 
  }

  onBackClick(){
    window.history.go(-1);
  }
}
SsoController.$inject = [ 'SsoAuthorizationService', 'config', '$state', '$cookies'];
  
export default SsoController;
  


// WEBPACK FOOTER //
// ./app/common/sso/sso.controller.js